import { isArray, isEmpty } from 'lodash';
import {
    IServiceRequestTypeV2,
    ServiceRequestTypeMap,
    ServiceRequestTypeTitlesMap,
    ServiceRequestTypeTitlesValues,
} from 'serviceRequest/types/serviceRequest';

export const generateServiceRequestTypeMap = (serviceRequestTypes?: IServiceRequestTypeV2[]): ServiceRequestTypeMap => {
    const result: ServiceRequestTypeMap = {};

    if (isEmpty(serviceRequestTypes) || !isArray(serviceRequestTypes)) {
        return result;
    }

    serviceRequestTypes.forEach((type) => (result[type.id] = type));

    return result;
};

export const generateServiceRequestTypeNamesMap = (
    serviceRequestTypes?: IServiceRequestTypeV2[],
): ServiceRequestTypeTitlesMap => {
    if (!serviceRequestTypes || isEmpty(serviceRequestTypes)) {
        return {};
    }

    const result: ServiceRequestTypeTitlesMap = {};

    for (const type of serviceRequestTypes) {
        const currentType: ServiceRequestTypeTitlesValues = { internalTitle: type?.internalTitle || '' };

        for (const title of type?.titles || []) {
            if (title.langCode && title.text) {
                currentType[title.langCode] = title.text;
            }
        }

        result[type.id] = currentType;
    }

    return result;
};
